import './main.scss';
import 'bootstrap';
import './assets/custom/redesign.scss';
import './assets/custom/bms.scss';

import './assets/fontAwesome/css/font-awesome.min.css';
import './assets/custom/style.css';
import './assets/custom/animate.css';

import React from 'react';
import { createRoot } from 'react-dom/client';

import socketClient from './data/sockets';
import Routes from './router';

import { loadStartupModelData } from './data/actions/startupLoaders';
import './data/licenceValidityNotifications';
import translate from './data/translations';
import { licenceValidityCheck } from './data/licenceValidityNotifications';
import { initKeycloak, initKeycloakOnAppLoad } from './keycloak';
import useStore from '@data/state/zustand';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/en';
import 'dayjs/locale/hr';
import 'dayjs/locale/sr';
import 'dayjs/locale/bs';
import rest from './data/restWrapper';

window.translate = translate;

// 🔹 Load application data
const LoadAppData = async () => {
    try {
        const location = window.location.href;
        await loadStartupModelData(socketClient, location.includes('/invoiceView'));
        licenceValidityCheck();
    } catch (err) {
        console.warn(err);
        console.log('SHOW ERROR LOADING SCREEN');
    }
};

dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

let locale = useStore.getState().locale || 'en';
if (locale === 'bh') {
    locale = 'bs';
}
dayjs.locale(locale);

// 🔹 Get root element
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

const root = createRoot(rootElement);

// 🔹 Initialize application
const initializeApp = async () => {
    try {
        let keycloakState = useStore.getState().keycloak;
        console.log('%cloading app data', 'color:green');

           if (navigator?.onLine) {
            const isPosOnPrem = await rest("/keycloakConfig", "GET");
            if (isPosOnPrem && isPosOnPrem.deployment === "posOnPrem") {
                console.log('on prem deployment skipping Keycloak init');
            } else {
                initKeycloakOnAppLoad()
                await initKeycloak(keycloakState?.refreshToken ? { onLoad: 'login-required' } : {});
            }
        } else {
            console.log('No internet connection, skipping Keycloak initialization');
        }

        await LoadAppData();
    } catch (err) {
        console.warn(err);
        console.log('SHOW ERROR LOADING SCREEN');
    }
};

// 🚀 Render first, then initialize
root.render(<Routes />);
initializeApp();
